import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert } from "react-bootstrap";
import _ from "lodash";
import ContactUsFormSection from "./ContactUsComponents/ContactUsFormSection";
import OfficeLocationsSection from "./ContactUsComponents/OfficeLocationsSection";
import FAQsSection from "./ContactUsComponents/FAQsSection";
import MetaSection from "./ContactUsComponents/MetaSection";
import { sanitizeData } from ".";

const ContactUsEditor = ({ data, onSave, onCancel, isLoading }) => {
  const defaultStructure = {
    contactUsForm: {
      isVisible: true,
      infoSection: {
        mainHeading: "",
        subHeading: "",
        fields: [
          { id: "phone", fieldName: "Phone", value: "" },
          { id: "email", fieldName: "Email", value: "" },
          { id: "address", fieldName: "Address", value: "" },
        ],
      },
      formSection: {
        heading: "",
        subHeading: "",
        formFields: [
          { id: "name", name: "Name", type: "text", placeholder: "Your Name" },
          {
            id: "email",
            name: "Email",
            type: "email",
            placeholder: "Your Email",
          },
          {
            id: "phone",
            name: "Phone",
            type: "tel",
            placeholder: "Your Phone",
          },
          {
            id: "message",
            name: "Message",
            type: "textarea",
            placeholder: "Your Message",
          },
        ],
      },
    },
    officeLocations: {
      isVisible: true,
      offices: [
        {
          location: "",
          name: "",
          designation: "",
          address: "",
          phone: "",
        },
      ],
    },
    faqsSection: {
      isVisible: true,
      heading: "",
      subHeading: "",
      faqs: [{ id: "faq1", question: "", answer: "" }],
    },
    meta: {
      title: "",
      description: "",
    },
  };

  const [formData, setFormData] = useState(defaultStructure);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "info",
  });

  useEffect(() => {
    if (data?.content) {
      setFormData({ ...defaultStructure, ...data.content });
    }
  }, [data]);

  const handleSectionUpdate = (sectionName, sectionData) => {
    setFormData((prev) => ({
      ...prev,
      [sectionName]: sectionData,
    }));
  };

  const handleSave = () => {
    const sanitizedData = sanitizeData(formData, defaultStructure);
    onSave({ pageName: data.pageName, content: sanitizedData });
  };

  return (
    <div className="col-12">
      {alert.show && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() =>
            setAlert({ show: false, message: "", variant: "info" })
          }
          className="mb-3"
        >
          {alert.message}
        </Alert>
      )}

      <div className="card p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <Button variant="link" className="p-0 me-3" onClick={onCancel}>
              ← Back
            </Button>
            <h4 className="m-0">Edit Contact Us Page</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <ContactUsFormSection
              data={formData.contactUsForm}
              onUpdate={(data) => handleSectionUpdate("contactUsForm", data)}
            />

            <OfficeLocationsSection
              data={formData.officeLocations}
              onUpdate={(data) => handleSectionUpdate("officeLocations", data)}
            />

            <FAQsSection
              data={formData.faqsSection}
              onUpdate={(data) => handleSectionUpdate("faqsSection", data)}
            />

            <MetaSection
              data={formData.meta}
              onUpdate={(data) => handleSectionUpdate("meta", data)}
            />

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsEditor;
